var _defs, _sodipodiNamedview;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyTargetSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 1200,
    height: 1200,
    viewBox: "0 0 1200 1200",
    sodipodiDocname: "1311358_458.eps",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2479.86,2446.19 c -0.02,0.04 -0.03,0.08 -0.05,0.12 0.03,-0.08 0.02,-0.04 0.05,-0.12 m -0.24,0.57 c -40.21,95.19 -73.33,198.52 -98.53,308.42 h 0.02 c 25.18,-109.88 58.31,-213.21 98.51,-308.42",
    id: "path140"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6692.67,1520.51 H 2338.71 c -77.57,0 -141.03,41.34 -141.03,91.88 0,50.54 63.46,91.89 141.03,91.89 h 481.87 c 35.17,-23 71.39,-43.26 108.68,-60.7 0.02,-0.01 0.04,-0.02 0.06,-0.02 0.22,-0.11 0.47,-0.22 0.69,-0.33 0.09,-0.04 0.2,-0.09 0.29,-0.13 0.15,-0.07 0.32,-0.15 0.47,-0.22 0.16,-0.08 0.35,-0.16 0.52,-0.24 0.07,-0.03 0.16,-0.07 0.23,-0.11 0.24,-0.11 0.51,-0.24 0.75,-0.35 h 0.01 c 95.73,-44.32 198.14,-69.86 305.71,-73.99 l -0.05,-0.59 h 28.59 c 0.83,0 1.65,0 2.48,0 0.83,0 1.64,0 2.48,0 h 265.74 c 162.43,0 321.49,48.49 470.86,136.68 h 92.57 c 1.12,-2.04 2.3,-4.03 3.52,-5.98 10.37,1.93 20.74,3.91 31.1,5.98 h 4.8 c -11.45,-2.88 -22.96,-5.57 -34.5,-8.16 18.5,-28.07 47.57,-46.26 80.43,-46.33 l 236.42,-0.23 c 22.01,10.1 43.79,20.67 65.27,31.81 -11.28,-10.81 -22.82,-21.33 -34.39,-31.84 l 343.3,-0.33 c 15.12,18.23 30.07,36.58 44.82,55.08 h 1851.24 c 77.57,0 141.04,-41.35 141.04,-91.89 0,-50.54 -63.47,-91.88 -141.04,-91.88",
    style: {
      fill: "#b9aac9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6211.6,3874.56 576.01,490.53 c 285.49,240.52 508.76,477.91 663.51,705.47 169.11,248.7 262.45,494.44 277.4,730.41 8.69,163.27 -23.92,307.62 -92.07,419.84 68.23,-112.25 100.88,-256.67 92.19,-420.04 -14.96,-235.98 -108.29,-481.71 -277.4,-730.41 -154.75,-227.56 -378.02,-464.95 -663.51,-705.47 l -576,-490.53 c -59.61,-71.24 -74.61,-143.82 -43.35,-210 2.99,-6.32 6.3,-12.42 9.89,-18.28 -3.64,5.93 -6.99,12.09 -10.01,18.48 -31.26,66.18 -16.26,138.76 43.34,210 z m 827.66,2428.99 c 113.81,97 274,104.82 408.09,19.91 57.22,-36.24 104.29,-85.44 140.11,-145.05 -35.81,59.52 -82.83,108.65 -139.99,144.85 -134.09,84.91 -294.28,77.09 -408.09,-19.91 -135.27,-115.28 -135.39,-115.08 -0.12,0.2 z m -800.9,-2833.04 13.18,26.9 c -49.23,21.96 -95.14,61.48 -124.82,111.23 29.68,-49.66 75.53,-89.1 124.7,-111.03 l 30.47,62.21 0.18,-0.08 22.46,45.85 c -94.22,45.6 -162.77,162.38 32.17,292.98 877.89,653.01 1465.48,1380.67 1455.91,1913.79 48.73,863.89 -1147.13,1050.05 -992.35,-121.8 l 164.71,-0.74 c -213.03,683.6 624.29,935.47 646.43,123.16 -86.04,-772.33 -761.35,-1183.79 -1459.93,-1834.61 -239.56,-234.05 -70.18,-488.54 86.89,-507.86",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6150.49,3980.52 c 698.59,650.82 1373.9,1062.27 1459.94,1834.6 -22.14,812.31 -858.54,558.59 -645.51,-125.01 l -61.98,-0.02 c -47.45,277.89 0.2,500.12 135.47,615.4 113.81,97.01 274,104.82 408.09,19.91 152.51,-96.57 232.89,-285.28 220.53,-517.73 -27.19,-428.75 -335.42,-894.43 -916.1,-1383.66 L 6170.82,3930 l -1.71,-2.03 c -108.72,-128.12 -81.12,-240.06 -55,-295.38 28.33,-59.98 87.84,-95.2 144.07,-120.28 l -19.76,-41.91 c -157.06,19.32 -327.48,276.06 -87.93,510.12",
    style: {
      fill: "#d99017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4312.16,3675.35 c -2.98,-6.42 -6.29,-12.61 -9.89,-18.57 3.55,5.9 6.83,12.02 9.77,18.36 30.84,66.45 15.38,138.9 -44.68,209.63 l -579.12,485.56 c -287.02,238.06 -511.8,473.52 -668,699.75 -170.69,247.24 -265.6,492.16 -282.06,728 -9.73,163.29 22,307.99 89.51,420.83 -67.43,-112.81 -99.12,-257.44 -89.39,-420.63 16.46,-235.84 111.37,-480.76 282.06,-728 156.2,-226.23 380.98,-461.69 667.99,-699.75 l 579.13,-485.56 c 60.06,-70.73 75.52,-143.17 44.68,-209.62 m -887.94,2631.23 c -114.43,96.02 -274.67,102.45 -408.21,16.39 -56.93,-36.68 -103.64,-86.22 -139.06,-146.05 35.44,59.92 82.19,109.53 139.18,146.25 133.54,86.06 293.78,79.63 408.21,-16.39 135.99,-114.12 135.88,-114.32 -0.12,-0.2 M 4326.95,3989.3 c -702.72,644.79 -1380.64,1050.43 -1471.61,1822 16.95,812.48 855.86,567.81 647.2,-117.6 l 164.7,2.16 c 147.3,1173.15 -1047.34,976.71 -993.09,113.26 -6.17,-533.19 586.05,-1255.77 1468.09,-1901.21 195.76,-128.92 127.96,-246.29 34.03,-292.7 l 22.75,-45.66 0.18,0.08 30.87,-61.93 c 49.03,22.34 94.62,62.17 123.99,112.09 -29.36,-50.01 -75.02,-89.92 -124.11,-112.3 l 13.35,-26.79 c 156.94,20.67 324.69,276.61 83.65,508.6",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4327.91,3991.45 c -702.72,644.79 -1380.64,1050.43 -1471.61,1822 16.95,812.48 854.95,565.95 646.29,-119.45 l 61.98,0.51 c 45.67,278.29 -3.4,500.1 -139.39,614.22 -114.43,96.02 -274.67,102.46 -408.22,16.39 -151.89,-97.88 -231.06,-287.27 -217.21,-519.61 29.92,-428.51 341.12,-891.52 924.91,-1375.74 l 583.24,-489.02 1.73,-2 c 109.54,-127.19 82.65,-239.36 56.88,-294.91 -27.94,-60.21 -87.23,-95.94 -143.29,-121.51 l 20.02,-41.74 c 156.94,20.67 325.71,278.87 84.67,510.86",
    style: {
      fill: "#d99017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3633.69,6594.09 c 35.18,-1314.32 401.19,-2403.19 1121.89,-3090.57 40.45,-38.74 82.12,-76.19 124.92,-112.07 9.18,-7.93 18.48,-15.6 27.78,-23.27 35.63,-29.25 71.93,-57.73 109.12,-85.17 0.34,-3.37 0.79,-6.75 1.23,-10.13 h 456.98 c 0.34,3.51 0.79,6.89 1.12,10.13 9.97,7.42 19.83,14.83 29.69,22.37 14.45,11.05 28.91,22.23 43.14,33.67 8.06,6.38 16.13,12.88 24.08,19.5 828.48,673.35 1227.88,1824.62 1264.06,3235.54 0.56,23.66 -4.81,45.89 -14.79,64.61 -17.81,33.67 -49.85,56.3 -86.49,56.3 H 3735.08 c -36.75,0 -68.79,-22.63 -86.49,-56.3 -9.97,-18.72 -15.46,-40.95 -14.9,-64.61",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6323.44,1788.48 v -25.8 c -1.2,-63.6 -46.1,-114.8 -101.4,-114.8 l -2036,1.9 c -56,0.1 -101.3,52.7 -101.3,117.7 v 19.1 c 0,17.3 3.2,33.8 9.1,48.6 15.6,39.7 49.7,67.5 89.7,68.9 379.1,14.2 641.2,145 801.7,376.9 1.2,1.7 2.5,3.39 3.6,5.1 7.8,11.3 15.3,22.89 22.5,34.7 1.1,1.7 2.2,3.39 3.3,5.2 6.8,1.6 15,29.8 23.4,75.79 1,5.61 2,11.31 3,17.4 1.8,10.81 3.6,22.41 5.4,34.6 18.3,124.31 36.1,318.81 41.2,488.61 1.6,49.09 1.9,96.2 1.1,138.89 -0.3,16.91 -0.9,33 -1.7,48.31 -0.3,6 -0.6,11.69 -1,17.4 -4.4,68.2 42.3,125.9 101.1,125.9 h 114.1 c 27.3,0 51.8,-12.4 69.8,-32.4 21.8,-23.9 34.2,-58.71 31.1,-96.31 l -0.1,-1.29 c -1.3,-14.6 -2.3,-29.9 -3.2,-45.8 -0.2,-5.41 -0.5,-11 -0.8,-16.8 -8.6,-194.1 7.4,-469.4 27.6,-626.51 1.6,-12.3 3.1,-23.89 4.8,-34.6 0.9,-6.09 1.8,-11.89 2.7,-17.4 8.2,-48.99 16.6,-76.09 24,-69.29 3,-4.3 6,-8.6 9.2,-12.9 4.5,-6.2 8.9,-12.4 13.5,-18.4 5.4,-7.21 10.8,-14.2 16.4,-21.1 181.5,-229.7 428.8,-349.1 732.6,-374.3 38.9,-3.2 71.6,-31.41 86.2,-70.6 5.4,-14.3 8.4,-30.1 8.4,-46.7",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5090.56,3164.66 c 44.87,4.89 90.81,2.06 135.59,-0.7 52.01,-3.2 103.83,-7.68 155.9,-9.14 10.38,-0.29 19.96,-1.7 29.12,-3.84 -3.13,-2.6 -6.21,-5.39 -9.4,-7.84 -1.23,-14.57 -2.24,-29.91 -3.13,-45.77 -25.77,-19.89 -52.99,-35.1 -81.34,-45.5 -27.45,-10.01 -55.9,-15.21 -85.03,-15.21 -50.75,0 -99.15,15.85 -143.74,44.85 -0.33,16.9 -0.89,33.02 -1.68,48.37 -1.98,1.31 -3.91,2.77 -5.87,4.15 4.07,9.31 7.38,19.46 9.58,30.63",
    style: {
      fill: "#d99017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4837.25,3747.69 c 0,-141.07 26.22,-271.86 71.03,-379.51 44.03,-106.22 106.1,-189.82 178.81,-238.58 45.82,-30.81 95.78,-47.71 148.21,-47.71 29.13,0 57.59,5.2 85.04,15.21 28.45,10.4 55.79,25.74 81.67,45.76 58.14,44.86 108.67,112.6 147.55,196.19 42.01,89.97 70.35,198.41 80.1,316.85 2.35,27.95 3.58,56.29 3.81,85.15 v 6.64 c 0,367.81 -178.25,665.93 -398.17,665.93 -210.73,0 -383.26,-273.94 -397.15,-620.69 -0.56,-14.95 -0.9,-30.03 -0.9,-45.24",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5173.55,3368.18 c -2.98,7.67 -5.96,15.34 -8.91,23.27 -13.73,35.88 -27.1,73.33 -40.08,112.07 -231.23,687.38 -348.66,1776.25 -359.95,3090.57 -0.18,23.66 1.59,45.89 4.79,64.61 5.67,33.67 15.95,56.3 27.74,56.3 h -757.67 c -30.34,0 -56.8,-22.63 -71.42,-56.3 -8.23,-18.72 -12.76,-40.95 -12.3,-64.61 29.05,-1314.32 331.28,-2403.19 926.4,-3090.57 33.39,-38.74 67.81,-76.19 103.15,-112.07 7.58,-7.93 15.26,-15.6 22.94,-23.27 29.42,-29.25 59.39,-57.73 90.1,-85.17 0.28,-3.37 0.65,-6.75 1.02,-10.13 h 109.6 c -0.14,3.38 -0.29,6.76 -0.4,10.13 -11.93,27.44 -23.58,55.92 -35.01,85.17",
    style: {
      fill: "#fcf1a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5319.89,3177.58 c 0.11,-27.05 0.22,-53.96 0.45,-80.48 1.56,-244.17 8.51,-466.49 26.44,-643.31 0.33,-3.65 0.78,-7.28 1.12,-10.79 68.34,-7.41 86.82,-88.02 44.47,-123.52 -3.58,-2.99 -7.73,-5.72 -12.32,-8.06 120.77,-384.32 497.31,-531.37 943.42,-548.79 v 25.88 c 0,61.88 -41.45,112.85 -94.66,117.27 -312.91,26 -565.99,151.85 -748.94,395.37 -4.59,5.98 -9.07,12.23 -13.55,18.46 11.42,0.27 22.07,4.55 30.8,11.57 15.35,12.1 25.32,32.38 25.32,55.52 0,18.59 -6.49,35.23 -16.91,47.45 -10.53,12.1 -24.88,19.64 -40.9,19.64 h -38.98 c -20.17,157.06 -36.19,432.42 -27.56,626.53 1.01,21.98 2.24,42.91 3.92,62.54 58.14,44.86 108.67,112.6 147.55,196.19 844.83,670.62 1251.62,1830.47 1288.14,3255.04 0.56,23.66 -4.81,45.89 -14.79,64.61 h 76.64 v 299.68 h -391.56 c -1.45,-67.09 -3.69,-176.81 -6.61,-243.38 -0.67,-18.72 -1.56,-37.58 -2.46,-56.3 -53.11,-1089.26 -291.4,-2086.72 -865.45,-2917.65 -62.18,-90.22 -128.39,-178.37 -198.75,-264.44 -8.29,-77.88 -19.38,-145.49 -46.27,-203.73 -5.15,-11.19 -10.87,-21.85 -17.36,-32.38 -13.56,-22.36 -30.36,-43.42 -51.2,-62.92",
    style: {
      fill: "#d99017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4936.27,2320.78 h 615.85",
    style: {
      fill: "none",
      stroke: "#d99017",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5297.66,2428.34 h 254.46",
    style: {
      fill: "none",
      stroke: "#d99017",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5093.25,2428.34 h 204.41",
    style: {
      fill: "none",
      stroke: "#facc07",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5016.57,2321.09 h -80.3 c -59.23,0 -107.25,48.02 -107.25,107.25 0,59.24 48.02,107.26 107.25,107.26 h 145.31 c 59.23,0 42.25,-48.02 42.25,-107.26 0,-59.23 -48.02,-107.25 -107.26,-107.25",
    style: {
      fill: "#d99017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5097.15,2986.06 h 275.58",
    style: {
      fill: "none",
      stroke: "#d99017",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5199.92,3077.23 h 172.81",
    style: {
      fill: "none",
      stroke: "#d99017",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5097.15,3077.23 h 39.43",
    style: {
      fill: "none",
      stroke: "#d99017",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4804.29,3456.19 h 872.33",
    style: {
      fill: "none",
      stroke: "#d99017",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5378.1,3574.17 h 298.52",
    style: {
      fill: "none",
      stroke: "#d99017",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4804.29,3574.17 H 5378.1",
    style: {
      fill: "none",
      stroke: "#facc07",
      strokeWidth: 214.507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3631,6601.49 3207.86,-107.26 v 185.93 H 3631 v -78.67",
    style: {
      fill: "#d99017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3584.73,6970.67 V 6671.12 H 6903.8 v 299.55 H 3584.73",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3785.05,6970.67 c 0.11,-87.24 1.23,-215.69 3.13,-299.55 h 392.45 c 1.01,83.72 1.91,212.18 2.47,299.55 h -398.05",
    style: {
      fill: "#fcf1a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4796.61,1649.2 c 135.34,163.18 257.49,336.48 342.79,531.79 16.33,37.39 10.7,80.08 -26.91,102.61 -2.55,1.53 -5.3,2.81 -8.13,3.98 2.78,5.23 5.6,10.42 8.31,15.7 2.63,5.12 4.6,10.21 6.05,15.23 h 62.4 c -32.49,56.18 -30.4,148.28 -2.88,208.33 13.96,5.03 48.34,3.34 48.34,3.34 0,0 -16.51,263.56 -13.2,371.41 0.87,0.14 1.68,0.25 2.59,0.41 3.58,1.51 7.16,3.02 10.75,4.53 1.2,0.65 2.17,1.55 3.26,2.32 4.78,-4.97 4.42,-0.2 4.37,4.58 -0.05,4.6 0.18,9.21 5.56,5.08 45.91,-35.25 111.28,5.84 65.92,40.66 -70.24,53.93 -76.26,151.14 -29.16,222.15 0.84,1.27 1.55,2.53 2.25,3.79 h 11.34 c -48.24,20.09 -61.98,141.79 -62.98,167.49 -0.87,21.59 28.58,109.84 7.02,111.31 -109.81,7.52 -94.81,205.02 -34.81,222.52 8.2,18 2.55,106.25 -0.75,127.55 -89.2,566.69 -439.9,1080.1 -930.5,1375.8 -93.9,56.69 -179.5,-90.3 -85.8,-146.7 214.4,-129.31 397.4,-302.7 539.6,-504.71 -29.2,7.01 -63.9,-2.5 -83.8,-22.39 -35.9,-35.9 -28.2,-83.8 0,-120.2 150.5,-194.4 209.2,-442.8 263.6,-678.31 -17.2,-11.29 -30,-28.99 -38,-49.39 -16.5,-42.5 -16.4,-87.9 -3.5,-131.3 3.6,-12 9.1,-21.91 15.7,-30.11 -13,-19.89 -17.2,-45.6 -12.7,-70.99 0.7,-4.01 1.6,-7.91 2.4,-11.9 -4.28,-2.73 -8.24,-5.97 -11.99,-9.52 8.88,-7.65 17.77,-15.29 26.75,-22.81 9.18,-7.93 18.48,-15.6 27.78,-23.27 43.98,-106.11 105.97,-189.64 178.58,-238.42 0.78,-15.31 1.34,-31.39 1.67,-48.25 l 0.23,-0.14 v -0.14 c 0.79,-42.64 0.45,-89.71 -1.12,-138.85 -4.52,-149.32 -13.53,-282.56 -29.4,-405.54 -0.78,-6.05 -6.79,-47.17 -7.58,-52.99 -1.41,-10.41 -2.82,-20.44 -4.24,-30.06 -1.8,-12.22 -3.59,-23.79 -5.38,-34.59 -1.01,-6.1 -2.02,-11.83 -3.02,-17.42 -8.41,-46.02 -16.59,-74.24 -23.42,-75.8 -1.01,-1.82 -2.13,-3.51 -3.25,-5.2 -7.17,-11.83 -14.68,-23.4 -22.52,-34.71 -1.12,-1.69 -2.35,-3.38 -3.58,-5.07 -134.01,-193.61 -338.81,-316.67 -623.32,-360.33 -85.5,-28.75 -172.86,-52.58 -261.05,-70.63 -10.2,-18.3 -16.15,-40.06 -16.15,-63.49 v -19.11 c 0,-25.89 7.27,-49.73 19.45,-69.14 17.99,3.35 35.97,6.85 53.91,10.66 -17.38,-4.7 -34.91,-8.89 -52.51,-12.84 18.5,-28.07 47.57,-46.26 80.43,-46.33 l 236.42,-0.23 c 22.01,10.1 43.79,20.67 65.27,31.81 -11.28,-10.81 -22.82,-21.33 -34.39,-31.84 l 343.3,-0.33",
    style: {
      fill: "#d99017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6323.44,1788.48 v -25.8 c -1.2,-63.6 -46.1,-114.8 -101.4,-114.8 l -2036,1.9 c -56,0.1 -101.3,52.7 -101.3,117.7 v 19.1 c 0,17.3 3.2,33.8 9.1,48.6 h 2221.2 c 5.4,-14.3 8.4,-30.1 8.4,-46.7",
    style: {
      fill: "#be621d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3882.48,6280.22 c -2.73,-143.87 55.33,-230.44 211.53,-224.52 -128.32,-8.79 -199.69,-102.45 -199.69,-241.37 -21.9,168.37 -107.56,219.3 -220.19,232.95 151.31,10.19 207.96,99.4 208.35,232.94",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3212.31,3538.77 c -19.01,3.36 326.96,-132.81 326.96,-132.81 0,0 -343.61,-77.92 -335.42,-78.05 l 8.46,210.86",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3852.45,5413.41 h -271 L 3237.94,1567.6 h 299.29 c 684.29,0 1309.61,860.93 1396.65,1922.91 87.04,1061.97 -397.14,1922.9 -1081.43,1922.9",
    style: {
      fill: "#211a1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3584.25,5413.41 c -684.29,0 -1309.6,-860.93 -1396.64,-1922.9 -87.05,-1061.98 397.13,-1922.91 1081.42,-1922.91 684.29,0 1309.61,860.93 1396.65,1922.91 87.04,1061.97 -397.14,1922.9 -1081.43,1922.9",
    style: {
      fill: "#241b1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4565.93,3490.55 c -2.29,-28.01 -18.85,-50.82 -36.91,-50.82 h -13.78 C 4425.13,2547.79 3903.38,1826.47 3327.03,1794.83 l -1.83,-21.7 c -2.28,-28.02 -18.85,-50.82 -36.91,-50.82 -18.05,0 -30.9,22.8 -28.62,50.82 l 1.72,21.04 c -289.01,10.61 -535.97,197.25 -703.68,493.44 -76.59,135.07 -136.61,293.04 -176.62,467.57 -47.04,205.26 -66.35,433.41 -52.15,674.22 h -7.26 c -18.16,0 -30.92,22.71 -28.63,50.83 2.29,28.01 18.85,50.82 36.91,50.82 h 6.98 c 87.37,900.04 614.63,1628.8 1195.87,1655.42 l 0.97,11.18 c 2.28,27.92 18.75,50.73 36.9,50.73 18.06,0 30.82,-22.81 28.54,-50.73 l -0.88,-11.18 c 190.67,-8.75 362.87,-94.29 505.79,-237.27 98.84,-98.86 183.68,-225.27 250.98,-372.9 73,-159.92 125.27,-344.79 152.41,-546.41 20.75,-154.24 26.8,-318.35 16.1,-488.6 h 13.68 c 18.06,0 30.91,-22.72 28.63,-50.74 m 86.41,607.48 c -30.34,229.83 -89.52,440.29 -172.41,622.37 -75.52,166.25 -170.79,308.76 -281.83,420.56 -171.77,172.95 -381.27,272.46 -613.89,272.46 -684.27,0 -1309.58,-860.95 -1396.61,-1922.87 -24.81,-303.17 -3.16,-589.97 56.44,-844.93 45.56,-195.01 113.25,-371.41 199.44,-522.39 195.59,-343.49 485.86,-555.63 825.53,-555.63 684.27,0 1309.58,860.95 1396.7,1922.95 17.39,212.33 12.02,416.56 -13.37,607.48",
    style: {
      fill: "#453445",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3588.11,5064.54 c -3.99,-25.25 -19.44,-44.79 -36.18,-44.79 -16.79,0 -28.99,19.54 -28.84,44.79 C 2985,5038.18 2497.32,4363.69 2415.51,3530.71 c 16.1,-2.88 27,-24.42 24.86,-50.47 -2.12,-25.91 -16.32,-47.24 -32.71,-50.4 -47.51,-826.96 331,-1492.55 863.78,-1513.64 2.53,27.67 18.95,50.05 36.89,50.05 17.74,0 30.43,-22.04 28.67,-49.4 533.11,31.56 1015.18,698.22 1099.71,1522.87 -17.72,0.52 -30.22,23.11 -27.95,50.79 2.27,27.77 18.47,50.28 36.27,50.79 50.87,828.15 -325.35,1497.08 -856.92,1523.24 m -84.43,-234.03 0.52,6.33 c 2.31,28.09 18.8,50.8 36.9,50.8 18.05,0 30.88,-22.71 28.57,-50.8 l -0.51,-6.33 c 448.37,-26.1 765.52,-590.05 725.08,-1289.2 h 7.39 c 18.05,0 30.88,-22.71 28.57,-50.8 -2.29,-28.01 -18.85,-50.8 -36.9,-50.8 h -7.38 C 4212.12,2744.05 3806.16,2182.24 3356.2,2150.93 l -0.98,-11.97 c -2.3,-28.01 -18.85,-50.8 -36.9,-50.8 -18.1,0 -30.92,22.79 -28.62,50.8 l 0.92,11.21 c -449.57,20.94 -769.07,581.55 -732.15,1279.26 h -4.4 c -18.05,0 -30.88,22.72 -28.57,50.81 2.29,28.01 18.85,50.8 36.89,50.8 h 3.91 c 71.21,703.88 482.54,1273.16 937.38,1299.47",
    style: {
      fill: "#241b1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3598.33,5186.49 -9.5,-115.94 c -0.17,-2.03 -0.41,-4.04 -0.72,-6.01 531.57,-26.16 907.79,-695.09 856.92,-1523.24 l 0.63,0.01 h 77.96 c 56.31,895.29 -350.55,1618.78 -925.29,1645.18 m -65.47,0 C 2951.55,5159.89 2424.34,4431.06 2336.92,3531.04 h 74.88 c 1.27,0 2.5,-0.11 3.71,-0.33 81.81,832.98 569.49,1507.47 1107.58,1533.83 0.02,1.97 0.1,3.98 0.27,6.01 l 9.5,115.94 M 4436.71,3439.72 C 4352.18,2615.07 3870.11,1948.41 3337,1916.85 l -0.1,-1.4 -9.89,-120.66 c 576.41,31.66 1098.17,753.01 1188.28,1644.92 h -77.96 l -0.62,0.01 m -2029.05,-9.88 c -1.38,-0.27 -2.78,-0.41 -4.19,-0.41 h -74.49 c -52.79,-893.99 356.46,-1614.06 932.46,-1635.25 l 9.94,121.27 0.06,0.75 c -532.78,21.09 -911.29,686.68 -863.78,1513.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3559.15,4708.42 -0.3,-3.68 c -2.3,-28.01 -18.85,-50.81 -36.9,-50.81 -18.1,0 -30.87,22.8 -28.58,50.81 l 0.31,3.68 C 3082.21,4682.23 2710.56,4167.6 2644.9,3531.04 h 2.62 c 18.1,0 30.86,-22.79 28.57,-50.8 -2.3,-28.09 -18.8,-50.81 -36.9,-50.81 h -2.08 c -31.54,-630.61 257.35,-1136.67 663.74,-1157.3 4.01,25.13 19.45,44.69 36.21,44.69 16.53,0 28.67,-19.12 28.84,-43.86 406.84,30.86 773.36,538.35 841.44,1167.15 -15.84,3.16 -26.59,24.56 -24.47,50.4 2.12,25.91 16.37,47.25 32.73,50.4 35.14,632.04 -251.34,1141.53 -656.45,1167.51 m -84.66,-234.12 0.98,11.97 c 2.3,28.09 18.8,50.81 36.9,50.81 18.05,0 30.87,-22.72 28.57,-50.81 l -0.98,-11.96 c 321.93,-25.63 549.43,-430.13 524.76,-933 h 7.76 13.09 c 18.05,0 30.87,-22.71 28.57,-50.8 -2.3,-28.01 -18.85,-50.8 -36.9,-50.8 h -13.08 -7.77 C 3999.03,2940.3 3708.84,2537.86 3385.4,2507.22 l -1.03,-12.55 c -2.3,-28.09 -18.85,-50.81 -36.89,-50.81 -18.11,0 -30.93,22.72 -28.63,50.81 l 0.94,11.5 c -323.15,20.54 -552.97,421.82 -531.75,923.26 h -8.08 c -18.05,0 -30.88,22.72 -28.57,50.81 2.29,28.01 18.85,50.8 36.9,50.8 h 7.41 c 54.89,507.58 350.47,917.36 678.79,943.26",
    style: {
      fill: "#241b1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3569.16,4830.51 -10.01,-122.09 c 405.11,-25.98 691.59,-535.47 656.45,-1167.51 1.38,0.27 2.77,0.4 4.17,0.4 h 74.47 c 40.44,699.15 -276.71,1263.1 -725.08,1289.2 m -65.48,0 C 3048.84,4804.2 2637.51,4234.92 2566.3,3531.04 h 78.6 c 65.66,636.56 437.31,1151.19 848.78,1177.38 l 10,122.09 m 703.66,-1390.4 c -68.08,-628.8 -434.6,-1136.29 -841.44,-1167.15 0.01,-2.27 -0.07,-4.59 -0.27,-6.95 l -9.43,-115.08 c 449.96,31.31 855.92,593.12 929.72,1288.78 h -74.48 c -1.4,0 -2.77,0.13 -4.1,0.4 m -1570.23,-10.68 h -78.64 c -36.92,-697.71 282.58,-1258.32 732.15,-1279.26 l 9.49,115.84 c 0.17,2.07 0.42,4.11 0.74,6.12 -406.39,20.63 -695.28,526.69 -663.74,1157.3",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3529.93,4352.21 c -2.9,-27.18 -19.09,-48.85 -36.72,-48.85 -17.67,0 -30.27,21.67 -28.7,48.84 -284.96,-25.64 -540.88,-380.86 -590.13,-821.18 17.58,-0.8 29.85,-23.28 27.6,-50.78 -2.23,-27.19 -17.75,-49.34 -35.16,-50.73 -15.98,-434.71 183.55,-781.61 463.84,-801.29 5.24,22.47 19.61,39.17 35.14,39.17 15.21,0 26.7,-16.14 28.57,-38.03 280.8,29.54 532.18,378.38 583.52,811.8 -13.86,5.43 -22.87,25.5 -20.91,49.35 1.96,23.92 14.25,43.94 29,49.36 19.84,436.27 -177.13,786.95 -456.05,812.34 m -84.62,-234.43 c 3,26.91 19.08,48.42 36.66,48.42 17.53,0 30.13,-21.5 28.73,-48.41 195.55,-24.54 333.55,-269.9 324.29,-576.48 h 1.78 c 18.05,0 30.87,-22.71 28.57,-50.8 -2.3,-28.01 -18.85,-50.8 -36.9,-50.8 h -1.78 c -40.52,-303.18 -215.18,-546.36 -412,-575.56 l -0.3,-3.67 c -2.31,-28.08 -18.85,-50.8 -36.9,-50.8 -18.1,0 -30.93,22.72 -28.62,50.8 l 0.16,2.02 c -196.79,19.7 -336.97,261.76 -330.96,566.95 -17.58,0.74 -29.94,23.17 -27.68,50.79 2.21,26.98 17.66,49.12 34.93,50.71 38.29,311.36 218.2,561.93 420.02,586.83",
    style: {
      fill: "#241b1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3539.96,4474.31 -9.85,-120.14 -0.18,-1.96 c 278.92,-25.39 475.89,-376.07 456.05,-812.34 2.57,0.94 5.22,1.44 7.9,1.44 h 70.84 c 24.67,502.87 -202.83,907.37 -524.76,933 m -65.47,-0.01 c -328.32,-25.9 -623.9,-435.68 -678.79,-943.26 h 77.71 l 0.97,-0.02 c 49.25,440.32 305.17,795.54 590.13,821.18 l 0.13,1.97 9.85,120.13 m 503.4,-1033.14 c -51.34,-433.42 -302.72,-782.26 -583.52,-811.8 0.35,-4.08 0.36,-8.36 0,-12.78 l -8.97,-109.36 c 323.44,30.64 613.63,433.08 670.99,932.49 h -70.84 c -2.68,0 -5.24,0.5 -7.66,1.45 m -1111.07,-11.65 -1.74,-0.08 h -77.04 c -21.22,-501.44 208.6,-902.72 531.75,-923.26 l 9.05,110.41 c 0.33,4 0.95,7.9 1.82,11.64 -280.29,19.68 -479.82,366.58 -463.84,801.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3500.7,3995.31 -0.15,-1.9 c -2.3,-28.01 -18.86,-50.81 -36.91,-50.81 -18.1,0 -30.86,22.8 -28.57,50.81 l 0.16,1.88 c -158.36,-24.28 -298.68,-220.26 -331.17,-464.25 h 1.81 c 18.04,0 30.86,-22.79 28.57,-50.8 -2.31,-28.09 -18.85,-50.81 -36.9,-50.81 h -0.49 c -1.03,-237.85 108.49,-425.57 261.97,-444.7 l 0.22,2.72 c 2.3,28.09 18.85,50.81 36.95,50.81 18.05,0 30.88,-22.72 28.57,-50.81 l -0.05,-0.68 c 153.4,28.25 288.52,217.06 323.03,452.94 h -1.17 c -18.09,0 -30.86,22.79 -28.57,50.8 2.31,28.09 18.8,50.8 36.9,50.8 h 1.17 c 4.21,239.28 -103.11,430.14 -255.37,454 m -85.08,-239.27 1.97,24.04 c 2.29,28.01 18.8,50.81 36.9,50.81 18.05,0 30.87,-22.8 28.57,-50.81 l -1.97,-24.01 c 70.41,-21.27 119.41,-111.62 121.1,-225.03 h 7.84 c 18.05,0 30.87,-22.79 28.58,-50.8 -2.31,-28.09 -18.86,-50.81 -36.9,-50.81 h -10.36 c -23.93,-103.66 -84.41,-184.51 -153.79,-204.48 l -1.14,-13.9 c -2.3,-28.09 -18.86,-50.88 -36.91,-50.88 -18.1,0 -30.86,22.79 -28.56,50.88 l 1.14,13.94 c -66.05,20.01 -113.24,100.83 -120.16,204.44 h -16.88 c -18.1,0 -30.93,22.72 -28.63,50.81 2.3,28.01 18.85,50.8 36.96,50.8 h 14.35 c 20.28,113.36 84.03,203.68 157.89,225",
    style: {
      fill: "#241b1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3510.7,4117.79 -0.16,-2.39 -9.84,-120.09 c 152.26,-23.86 259.58,-214.72 255.37,-454 h 78.92 c 9.26,306.58 -128.74,551.94 -324.29,576.48 m -65.39,-0.01 c -201.82,-24.9 -381.73,-275.47 -420.02,-586.83 l 1.97,0.09 h 76.8 c 32.49,243.99 172.81,439.97 331.17,464.25 l 9.84,120.11 0.24,2.38 m 381.35,-678.07 h -78.92 c -34.51,-235.88 -169.63,-424.69 -323.03,-452.94 l -10.05,-122.62 c 196.82,29.2 371.48,272.38 412,575.56 m -808.62,-10.26 C 3012.03,3124.26 3152.21,2882.2 3349,2862.5 l 10.02,122.23 c -153.48,19.13 -263,206.85 -261.97,444.7 h -78.12 l -0.89,0.02",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3481.09,3756.07 -10.11,-123.34 c -0.31,-3.84 -0.89,-7.57 -1.71,-11.16 24.84,-15.29 42.41,-48.8 47.1,-90.53 h 85.82 c -1.69,113.41 -50.69,203.76 -121.1,225.03 m -65.47,-0.03 c -73.86,-21.32 -137.61,-111.64 -157.89,-225 h 80.54 c 1.76,0 3.47,-0.22 5.12,-0.63 11.46,41.96 34.59,75.69 62,91.09 -0.23,3.61 -0.19,7.37 0.12,11.23 l 10.11,123.31 m -75.72,-324.31 c -3.21,-1.49 -6.55,-2.3 -9.96,-2.3 h -78.01 c 6.92,-103.61 54.11,-184.43 120.16,-204.44 l 10.93,133.34 0.16,1.72 c -20.67,13.15 -36.2,39 -43.28,71.68 m 163.09,-1.95 c -12.49,-31.81 -31.97,-56.92 -54.38,-69.79 l -0.12,-1.66 -10.93,-133.38 c 69.38,19.97 129.86,100.82 153.79,204.48 h -84.59 c -1.29,0 -2.54,0.12 -3.77,0.35",
    style: {
      fill: "#f03a1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3469.27,3621.57 c -5.14,-22.71 -19.6,-39.65 -35.19,-39.65 -15.61,0 -27.26,16.91 -28.69,39.58 -27.41,-15.4 -50.54,-49.13 -62,-91.09 15.32,-3.85 25.53,-24.88 23.45,-50.17 -1.86,-22.81 -13.09,-42.07 -26.94,-48.51 7.08,-32.68 22.61,-58.53 43.28,-71.68 2.82,27.29 19.01,49.08 36.74,49.08 17.69,0 30.36,-21.82 28.69,-49.14 22.41,12.87 41.89,37.98 54.38,69.79 -16.07,2.91 -26.94,24.36 -24.8,50.46 2.29,28.01 18.79,50.8 36.9,50.8 h 1.28 c -4.69,41.73 -22.26,75.24 -47.1,90.53",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4085.57,3541.31 h -13.09 c 18.05,0 30.88,-22.71 28.58,-50.8 -2.3,-28.01 -18.85,-50.8 -36.9,-50.8 h 13.08 c 18.05,0 34.6,22.79 36.9,50.8 2.3,28.09 -10.52,50.8 -28.57,50.8",
    style: {
      fill: "#ed1d24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4537.35,3541.31 h -91.69 l -0.63,-0.01 c -17.8,-0.51 -34,-23.02 -36.27,-50.79 -2.27,-27.69 10.23,-50.27 27.95,-50.79 l 0.62,-0.01 h 77.96 13.73 c 18.05,0 34.6,22.79 36.9,50.8 2.3,28.09 -10.52,50.8 -28.57,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4301.63,3541.31 h -81.86 c -1.4,0 -2.79,-0.13 -4.17,-0.4 -16.36,-3.15 -30.61,-24.49 -32.73,-50.4 -2.12,-25.84 8.62,-47.24 24.47,-50.4 1.33,-0.27 2.7,-0.4 4.1,-0.4 h 74.48 7.39 c 18.04,0 34.6,22.79 36.89,50.8 2.31,28.09 -10.52,50.8 -28.57,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4072.48,3541.31 h -78.6 c -2.68,0 -5.33,-0.5 -7.9,-1.44 -14.75,-5.42 -27.04,-25.44 -29,-49.36 -1.96,-23.85 7.05,-43.92 20.91,-49.35 2.42,-0.95 4.98,-1.45 7.66,-1.45 h 70.84 7.77 c 18.05,0 34.6,22.79 36.9,50.8 2.3,28.09 -10.53,50.8 -28.58,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3836.77,3541.31 h -81.87 c -18.1,0 -34.59,-22.71 -36.9,-50.8 -2.29,-28.01 10.47,-50.8 28.58,-50.8 h 1.16 78.92 1.78 c 18.05,0 34.6,22.79 36.9,50.8 2.3,28.09 -10.52,50.8 -28.57,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2411.8,3531.04 h -81.81 c -18.1,0 -34.66,-22.79 -36.95,-50.8 -2.31,-28.09 10.52,-50.81 28.62,-50.81 h 7.32 74.49 c 1.41,0 2.81,0.14 4.19,0.41 16.39,3.16 30.59,24.49 32.71,50.4 2.14,26.05 -8.76,47.58 -24.86,50.47 -1.21,0.22 -2.45,0.33 -3.71,0.33",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2647.52,3531.04 h -85.13 c -18.04,0 -34.6,-22.79 -36.9,-50.8 -2.3,-28.09 10.53,-50.81 28.58,-50.81 h 4.4 78.64 2.08 c 18.1,0 34.6,22.72 36.9,50.81 2.29,28.01 -10.47,50.8 -28.57,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2873.41,3531.04 h -85.12 c -18.05,0 -34.61,-22.79 -36.91,-50.8 -2.3,-28.09 10.53,-50.81 28.58,-50.81 h 8.08 77.04 l 1.74,0.07 c 17.41,1.4 32.93,23.55 35.16,50.74 2.25,27.5 -10.02,49.98 -27.6,50.78 l -0.97,0.02",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3105.87,3531.04 h -78.61 l -1.97,-0.09 c -17.27,-1.58 -32.72,-23.73 -34.93,-50.71 -2.26,-27.63 10.1,-50.05 27.68,-50.79 l 0.89,-0.02 h 78.12 0.49 c 18.05,0 34.6,22.72 36.9,50.81 2.29,28.01 -10.53,50.8 -28.57,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3338.27,3531.04 h -94.89 c -18.11,0 -34.66,-22.79 -36.96,-50.8 -2.3,-28.09 10.53,-50.81 28.63,-50.81 h 16.88 78.01 c 3.41,0 6.75,0.81 9.96,2.3 13.85,6.44 25.08,25.7 26.94,48.51 2.08,25.29 -8.13,46.32 -23.45,50.17 -1.65,0.41 -3.36,0.63 -5.12,0.63",
    style: {
      fill: "#f03a1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3610.03,3531.04 h -94.94 c -18.1,0 -34.61,-22.79 -36.9,-50.8 -2.14,-26.1 8.73,-47.55 24.8,-50.46 1.23,-0.23 2.48,-0.35 3.77,-0.35 h 84.59 10.36 c 18.05,0 34.59,22.72 36.9,50.81 2.29,28.01 -10.53,50.8 -28.58,50.8",
    style: {
      fill: "#f03a1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3308.33,1966.25 c -17.94,0 -34.36,-22.39 -36.89,-50.05 l -0.06,-0.76 -9.94,-121.26 -1.73,-21.03 c -2.29,-28.01 10.53,-50.81 28.63,-50.81 18.04,0 34.6,22.8 36.9,50.81 l 1.77,21.64 9.89,120.65 0.1,1.41 c 1.76,27.36 -10.93,49.4 -28.67,49.4",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3337.06,2316.82 c -16.76,0 -32.2,-19.56 -36.21,-44.69 -0.32,-2.01 -0.57,-4.05 -0.74,-6.12 l -9.5,-115.84 -0.91,-11.21 c -2.3,-28.01 10.52,-50.8 28.62,-50.8 18.05,0 34.6,22.79 36.9,50.8 l 0.98,11.97 9.43,115.08 c 0.2,2.36 0.28,4.68 0.27,6.95 -0.17,24.74 -12.31,43.86 -28.84,43.86",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3365.8,2667.39 c -15.52,0 -29.9,-16.7 -35.14,-39.17 -0.87,-3.74 -1.49,-7.64 -1.82,-11.64 l -9.05,-110.41 -0.94,-11.5 c -2.3,-28.09 10.52,-50.81 28.62,-50.81 18.05,0 34.6,22.72 36.9,50.81 l 1.03,12.55 8.97,109.36 c 0.36,4.42 0.35,8.7 0,12.78 -1.86,21.89 -13.36,38.03 -28.57,38.03",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3396.19,3038.26 c -18.1,0 -34.65,-22.72 -36.95,-50.81 l -0.22,-2.72 -10.02,-122.23 -0.17,-2.02 c -2.3,-28.08 10.53,-50.8 28.63,-50.8 18.05,0 34.6,22.72 36.9,50.8 l 0.3,3.67 10.05,122.62 0.06,0.68 c 2.3,28.09 -10.53,50.81 -28.58,50.81",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3570.67,5248.4 c -18.1,0 -34.6,-22.79 -36.9,-50.8 l -0.91,-11.11 -9.5,-115.94 c -0.17,-2.03 -0.25,-4.04 -0.26,-6.01 -0.16,-25.25 12.04,-44.79 28.83,-44.79 16.74,0 32.19,19.54 36.18,44.79 0.31,1.97 0.55,3.98 0.72,6.01 l 9.5,115.94 0.91,11.11 c 2.3,28.01 -10.52,50.8 -28.57,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3541.1,4887.64 c -18.1,0 -34.59,-22.71 -36.9,-50.8 l -0.52,-6.33 -10,-122.09 -0.3,-3.68 c -2.3,-28.01 10.47,-50.81 28.57,-50.81 18.05,0 34.6,22.8 36.9,50.81 l 0.3,3.68 10.01,122.09 0.51,6.33 c 2.31,28.09 -10.52,50.8 -28.57,50.8",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3512.37,4537.08 c -18.1,0 -34.6,-22.72 -36.9,-50.81 l -0.98,-11.97 -9.85,-120.13 -0.13,-1.97 c -1.57,-27.17 11.03,-48.84 28.7,-48.84 17.63,0 33.83,21.67 36.72,48.85 l 0.18,1.96 9.85,120.14 0.98,11.96 c 2.3,28.09 -10.52,50.81 -28.57,50.81",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3481.97,4166.2 c -17.58,0 -33.66,-21.51 -36.67,-48.42 l -0.23,-2.38 -9.84,-120.11 -0.16,-1.88 c -2.29,-28.01 10.48,-50.81 28.57,-50.81 18.05,0 34.61,22.8 36.91,50.81 l 0.15,1.9 9.84,120.09 0.16,2.39 c 1.4,26.9 -11.2,48.41 -28.73,48.41",
    style: {
      fill: "#ee2c21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3454.49,3830.89 c -18.1,0 -34.61,-22.8 -36.9,-50.81 l -1.97,-24.04 -10.11,-123.31 c -0.31,-3.86 -0.35,-7.62 -0.12,-11.23 1.43,-22.67 13.08,-39.58 28.69,-39.58 15.59,0 30.05,16.94 35.19,39.65 0.82,3.59 1.4,7.32 1.71,11.16 l 10.11,123.34 1.97,24.01 c 2.3,28.01 -10.52,50.81 -28.57,50.81",
    style: {
      fill: "#f03a1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3419.92,3409.13 c -17.73,0 -33.91,-21.79 -36.74,-49.08 l -0.16,-1.72 -10.93,-133.34 -1.14,-13.94 c -2.3,-28.09 10.46,-50.88 28.56,-50.88 18.05,0 34.61,22.79 36.91,50.88 l 1.14,13.9 10.93,133.38 0.12,1.66 c 1.67,27.32 -11,49.14 -28.69,49.14",
    style: {
      fill: "#f03a1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g138",
    clipPath: "url(#clipPath142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2381.09,2446.19 h 98.7695 v 308.988 H 2381.09 Z",
    style: {
      fill: "#1b1517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 2443.49,2123.23 c -86.19,150.98 -153.88,327.38 -199.44,522.39 l 137.05,109.56 c 25.19,-109.9 58.31,-213.23 98.52,-308.42 0.05,-0.12 0.13,-0.32 0.19,-0.45 0.02,-0.04 0.03,-0.08 0.05,-0.12 23.57,-55.77 49.58,-108.77 77.82,-158.64 l -114.19,-164.32",
    style: {
      fill: "#2d1f2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2620.04,2374.17 c -71.49,126.28 -127.49,274.09 -164.58,437.33 l 142.64,108.03 c 31.54,-141.72 79.72,-269.89 141.56,-379.2 l -119.62,-166.16",
    style: {
      fill: "#1b1517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2557.68,2287.55 c -28.24,49.87 -54.25,102.87 -77.82,158.64 -0.03,0.08 -0.02,0.04 -0.05,0.12 -0.06,0.13 -0.14,0.33 -0.19,0.45 -40.2,95.21 -73.33,198.54 -98.51,308.43 l 74.35,56.31 c 37.09,-163.24 93.09,-311.05 164.58,-437.33 l -62.32,-86.56 -0.04,-0.06",
    style: {
      fill: "#a488a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2801.98,2626.91 c -56.78,100.44 -100.91,218.45 -129.53,348.92 l 142.7,108.08 c 23.01,-108.96 59.32,-207.38 106.44,-290.86 l -119.61,-166.14",
    style: {
      fill: "#1b1517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2739.66,2540.33 c -61.84,109.31 -110.02,237.48 -141.56,379.2 l 74.35,56.3 c 28.62,-130.47 72.75,-248.48 129.53,-348.92 l -62.32,-86.58",
    style: {
      fill: "#a16f1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2983.96,2879.68 c -42.09,74.62 -74.3,162.85 -94.37,260.61 l 142.89,108.22 c 14.3,-76.32 38.65,-145.08 71.06,-202.72 l -119.58,-166.11",
    style: {
      fill: "#1b1517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2921.59,2793.05 c -47.12,83.48 -83.43,181.9 -106.44,290.86 l 74.44,56.38 c 20.07,-97.76 52.28,-185.99 94.37,-260.61 l -62.37,-86.63",
    style: {
      fill: "#a488a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3165.89,3132.39 c -27.36,48.8 -47.57,107.46 -58.78,172.64 l 145.99,110.57 c 4.55,-43.9 16.44,-83.23 33.97,-114.88 l -121.18,-168.33",
    style: {
      fill: "#1b1517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3103.54,3045.79 c -32.41,57.64 -56.76,126.4 -71.06,202.72 l 74.63,56.52 c 11.21,-65.18 31.42,-123.84 58.78,-172.64 l -62.35,-86.6",
    style: {
      fill: "#a16f1e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3287.07,3300.72 c -17.53,31.65 -29.42,70.98 -33.97,114.88 l 18.27,13.83 h 58.57 c 3.41,0 6.75,0.81 9.96,2.3 v 0 c 3.09,-14.27 7.8,-27.23 13.83,-38.41 l -66.66,-92.6",
    style: {
      fill: "#a62521",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3353.73,3393.32 c -6.03,11.18 -10.74,24.14 -13.83,38.41 13.85,6.44 25.08,25.7 26.94,48.51 0.13,1.48 0.2,2.95 0.24,4.4 l 28.64,-5.05 c 3.09,-4.6 7.73,-8.07 13.17,-9.66 l -55.16,-76.61",
    style: {
      fill: "#a488a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3329.94,3429.43 h -58.57 l 77.2,58.47 18.51,-3.26 c -0.04,-1.45 -0.11,-2.92 -0.24,-4.4 -1.86,-22.81 -13.09,-42.07 -26.94,-48.51 v 0 c -3.21,-1.49 -6.55,-2.3 -9.96,-2.3",
    style: {
      fill: "#a62521",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3415.62,3468.98 c -2.34,0 -4.6,0.33 -6.73,0.95 l 4.68,6.51 -17.85,3.15 c -2.56,3.81 -4.06,8.4 -4.06,13.34 0,13.23 10.73,23.95 23.96,23.95 13.23,0 23.95,-10.72 23.95,-23.95 0,-13.23 -10.72,-23.95 -23.95,-23.95",
    style: {
      fill: "#a488a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3408.89,3469.93 c -5.44,1.59 -10.08,5.06 -13.17,9.66 l 17.85,-3.15 -4.68,-6.51",
    style: {
      fill: "#66476a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4506.58,4036.76 c -0.02,0.19 -0.05,0.4 -0.08,0.6 0.03,-0.21 0.05,-0.39 0.08,-0.6 m -0.13,0.95 c -24.56,177.75 -68.7,342.27 -129.31,488.06 60.65,-145.76 104.77,-310.32 129.31,-488.06",
    style: {
      fill: "#35262d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4507.52,4029.89 c -0.31,2.28 -0.62,4.59 -0.94,6.87 -0.03,0.21 -0.05,0.39 -0.08,0.6 -0.02,0.15 -0.03,0.2 -0.05,0.35 -24.54,177.74 -68.66,342.3 -129.31,488.06 -70.41,169.34 -163.08,313.46 -273,423.45 l 93.96,191.74 c 111.04,-111.8 206.31,-254.31 281.83,-420.56 82.89,-182.08 142.07,-392.54 172.41,-622.37 l -144.82,-68.14",
    style: {
      fill: "#6b4f6d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4280.07,3922.81 c -42.39,307.07 -158.73,564.27 -323.25,725.79 l 96.84,197.61 c 191.76,-190.82 327.08,-492.98 375.92,-853.01 l -149.51,-70.39",
    style: {
      fill: "#35262d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4429.58,3993.2 c -48.84,360.03 -184.16,662.19 -375.92,853.01 l 50.47,102.99 0.01,0.02 c 109.92,-109.99 202.59,-254.11 273,-423.45 60.61,-145.79 104.75,-310.31 129.31,-488.06 0.02,-0.15 0.03,-0.2 0.05,-0.35 0.03,-0.2 0.06,-0.41 0.08,-0.6 0.32,-2.28 0.63,-4.59 0.94,-6.87 v 0 l -77.94,-36.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4052.51,3815.69 c -32.6,226.34 -120.1,415.2 -243.13,532.07 l 96.9,197.73 c 150.32,-146.23 256.78,-379.97 295.82,-659.38 l -149.59,-70.42",
    style: {
      fill: "#35262d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4202.1,3886.11 c -39.04,279.41 -145.5,513.15 -295.82,659.38 l 50.54,103.11 c 164.52,-161.52 280.86,-418.72 323.25,-725.79 l -77.97,-36.7",
    style: {
      fill: "#f8e907",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3824.9,3708.54 c -22.83,145.6 -81.52,266 -163.07,338.13 l 97.01,197.96 c 108.82,-101.56 186.45,-266.98 215.7,-465.65 l -149.64,-70.44",
    style: {
      fill: "#35262d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3974.54,3778.98 c -29.25,198.67 -106.88,364.09 -215.7,465.65 l 50.54,103.13 c 123.03,-116.87 210.53,-305.73 243.13,-532.07 l -77.97,-36.71",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3594.86,3600.24 c -13.1,63.99 -42.82,114.89 -82.65,141.12 l 98.94,201.91 c 67.37,-56.69 116.18,-153.58 135.67,-271.49 l -151.96,-71.54",
    style: {
      fill: "#35262d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3746.82,3671.78 c -19.49,117.91 -68.3,214.8 -135.67,271.49 l 50.68,103.4 c 81.55,-72.13 140.24,-192.53 163.07,-338.13 l -78.08,-36.76",
    style: {
      fill: "#f8e907",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3510.55,3560.55 c -8.08,27.79 -22.63,49.54 -41.28,61.02 0.82,3.59 1.4,7.32 1.71,11.16 l 2.41,29.43 38.82,79.2 c 39.83,-26.23 69.55,-77.13 82.65,-141.12 l -84.31,-39.69",
    style: {
      fill: "#f2591a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3450.84,3532.45 -16.73,49.47 c 15.57,0.02 30.02,16.95 35.16,39.65 v 0 c 18.65,-11.48 33.2,-33.23 41.28,-61.02 l -59.71,-28.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3434.11,3581.92 -0.02,0.05 39.3,80.19 -2.41,-29.43 c -0.31,-3.84 -0.89,-7.57 -1.71,-11.16 v 0 0 c -5.14,-22.7 -19.59,-39.63 -35.16,-39.65",
    style: {
      fill: "#f2591a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1188.03,3830.14 c 38.85,-6.46 60.53,18.86 48.17,56.26 l -28.01,84.76 c -12.35,37.4 -54.25,73.28 -93.11,79.73 l -362.4,60.21 c -38.852,6.45 -60.532,-18.86 -48.172,-56.26 l 28.008,-84.76 c 12.359,-37.4 54.257,-73.28 93.113,-79.74 l 362.401,-60.2",
    style: {
      fill: "#f79110",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1188.23,3829.69 c 38.82,-6.67 51.27,-37.91 27.66,-69.44 l -53.73,-71.78 c -23.61,-31.53 -67.58,-53.19 -97.73,-48.14 -30.14,5.06 -70.399,11.79 -89.465,14.96 -19.067,3.18 -66.344,11.67 -105.067,18.88 l -207.484,38.63 c -38.723,7.21 -48.598,36.83 -21.949,65.84 l 66.68,72.56 c 26.652,29 80.214,47.28 119.031,40.62 l 362.054,-62.13",
    style: {
      fill: "#facc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3314.67,3482.74 754.895,3868.9 c -14.157,2.2 -23.848,15.46 -21.653,29.61 v 0 c 2.196,14.15 15.449,23.85 29.606,21.65 L 3322.63,3534 c 14.15,-2.2 23.85,-15.46 21.65,-29.61 -2.2,-14.16 -15.45,-23.85 -29.61,-21.65",
    style: {
      fill: "#502123",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 733.242,3898.51 v 0 c 2.196,14.15 15.449,23.85 29.606,21.65 L 3322.63,3534 c 14.15,-2.2 23.85,-15.46 21.65,-29.61 L 733.242,3898.51",
    style: {
      fill: "#632a2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1146.74,3766.59 -137.11,-117.07 -69.329,11.54 c 86.779,44.95 206.439,105.53 206.439,105.53",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3413.57,3476.44 c -77.37,-6.26 -189.1,-2.28 -189.1,-2.28 l 5.93,39.13 7.54,49.66 c 0,0 109.21,-24.71 180.91,-54.51 l 1.26,-17.66 -6.54,-14.34",
    style: {
      fill: "#524463",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3420.11,3490.78 -188.97,27.35 6.8,44.82 c 0,0 109.21,-24.71 180.91,-54.51 l 1.26,-17.66",
    style: {
      fill: "#9075b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path212"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyTargetSuccess);
export default __webpack_public_path__ + "static/media/trophy-target-success.1effc8d5f2e9ffc18d00e11868be8ea1.svg";
export { ForwardRef as ReactComponent };